import cx from "classnames";
import { Link } from "react-router";

import { useDashboardContext } from "@/layouts/dashboard-layout";

import { BigSidebarWrapper } from "@/components/wrappers";

import { NavLinks, Logo } from ".";

const BigSidebar = () => {
  const { sidebar } = useDashboardContext();

  return (
    <BigSidebarWrapper>
      <div className={cx("sidebar-container", { "show-sidebar": !sidebar })}>
        <div className="content">
          <header>
            <Link to=".">
              <Logo />
            </Link>
          </header>
          <NavLinks isBigSidebar />
        </div>
      </div>
    </BigSidebarWrapper>
  );
};

export default BigSidebar;
